module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.create.title')) + " " + _vm._s(_vm.currentStockProducts.length > 0 ? (" - " + (_vm.$t('static.purchase.create.unfinished'))) : ''))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.purchase.basicInformation'),
      "name": "first"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formBasicInformation,
      "translation": "form.purchase",
      "hasLabel": true
    }
  }) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('v-products-table', {
    attrs: {
      "additionalData": _vm.additionalData,
      "fields": _vm.fields,
      "page": "purchase"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [(_vm.currentStockProducts.length > 0) ? _c('el-button', {
    staticClass: "outline danger",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.destroy
    }
  }, [_vm._v(_vm._s(_vm.$t('button.delete').toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "outline dark",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": function($event) {
        return _vm.store('draft')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft').toUpperCase()))]), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": function($event) {
        return _vm.store()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f95a4f4","hasScoped":false}!./src/app/pages/withNavigation/purchase/create/create.html
// module id = 3005
// module chunks = 1